import styled from "styled-components"

import { Typography } from "components/common"

const Text = styled(Typography).attrs((props) => ({
  color: "neutral",
  fontSize: { _: 14, tablet: 16 },
  fontWeight: props.subtitle ? 700 : 300,
  lineHeight: "18px",
  mb: 2,
  ...props,
}))`
  a {
    color: ${(props) => props.theme.colors.primary};
    font-weight: normal;
  }
  b {
    font-weight: 600;
  }
  :last-child {
    margin-bottom: 0;
  }
`

export default Text
